export default __webpack_public_path__ + "static/media/paperclip.4689a759.svg";